import {PropertyBase} from "./PropertyBase";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import * as React from "react";
import {RNCheckBox} from "shared/controls/SingleInputs/RNCheckBox/RNCheckBox";
declare let rednaoPDFInvoiceParams:any;

export class CheckBoxProperty extends PropertyBase{
    public label:string='Text';

    public SubRenderer(): React.ReactNode {
        return (
            <RNCheckBox style={{margin:'20px 0'}} Label={this.label} Value={this.GetOptionValue(this.OptionsPropertyName)}   onChange={e=>this.SetOptionValue(e,this.OptionsPropertyName)} disabled={this.disabled}/>
        )
    }



}

